import { toast } from "@/utils/notifications";
import { captureExceptionWithoutPhi } from "@/utils/sentry";

import EncounterEmailSender from "./EncounterEmailSender";
import { EncounterEmailSenderType } from "./EncounterEmailSenderType";

/**
 * Emails the client about an amendment that has already saved. A failure is reported but does not
 * fail the amendment, so the provider is not prompted to repeat writes that already succeeded.
 *
 * @param emailDetails What `EncounterEmailSender` needs to decide on and send the email.
 * @param encounterId The amended encounter's id, the only identifier the failure report carries.
 */
export async function notifyClientOfAmendment(
  emailDetails: EncounterEmailSenderType,
  encounterId: string,
): Promise<void> {
  try {
    await EncounterEmailSender(emailDetails);
  } catch (error) {
    captureExceptionWithoutPhi("Failed to email the client about an encounter amendment", error, {
      encounterId,
    });
    toast({
      title: "Client email not sent",
      message: "The amendment was saved, but the client could not be emailed about it.",
      type: "warning",
      autoClose: false,
      id: "amend-encounter-email-failed",
    });
  }
}
